import type { PlaysetActionResponse, PlaysetParams, PlaysetScope } from '@/types'
import { request } from './client'

function buildPlaysetBody(scope: PlaysetScope, params: PlaysetParams) {
  return {
    setCode: scope.setCode ?? null,
    cardIds: scope.cardIds ?? null,
    numPlaysets: params.numPlaysets,
    mode: params.mode,
  }
}

export async function buylistMissing(scope: PlaysetScope, params: PlaysetParams): Promise<PlaysetActionResponse> {
  return request<PlaysetActionResponse>('/playset/buylist_missing', {
    method: 'POST',
    body: buildPlaysetBody(scope, params),
  })
}

export async function selllistExtras(scope: PlaysetScope, params: PlaysetParams): Promise<PlaysetActionResponse> {
  return request<PlaysetActionResponse>('/playset/selllist_extras', {
    method: 'POST',
    body: buildPlaysetBody(scope, params),
  })
}
